import Axios from 'axios';
import {
  assignUpidToProduct,
  isColorVariation,
  isSameMasterProduct,
  isSizeVariation,
} from '../../../common/helpers/productModelHelpers';

const productDetails = (serverData = {}) => ({
  product: serverData.product,
  addToCartUrl: serverData.addToCartUrl,
  recommendedProducts: serverData.recommendedProducts,
  resources: serverData.resources,
  breadcrumbs: serverData.breadcrumbs,
  canonicalUrl: serverData.canonicalUrl,
  schemaData: serverData.schemaData,
  pageType: serverData.pageType,
});

export const types = {
  init: 'product/init',
  load: 'product/load',
  loading: 'product/loading',
  update: 'product/update',
  removeProduct: 'product/removeProduct',
  updateWithVariation: 'product/updateWithVariation',
};

export default {
  namespaced: true,
  state: {
    loading: false,
    details: productDetails(),
    urls: {
      productShow: undefined,
    },
  },
  mutations: {
    loading(state, loading = true) {
      state.loading = loading;
    },
    init(state, productShowUrl) {
      state.urls.productShow = productShowUrl;
    },
    update(state, newProductDetails) {
      assignUpidToProduct(newProductDetails.product);
      state.details = newProductDetails;
    },
    updateWithVariation(state, productVariation) {
      const currentProduct = state.details.product;
      if (
        currentProduct &&
        isSameMasterProduct(currentProduct, productVariation)
      ) {
        const hasColorChanged = isColorVariation(
          currentProduct,
          productVariation
        );
        const hasSizeChanged = isSizeVariation(
          currentProduct,
          productVariation
        );

        if (hasSizeChanged) {
          // Avoid re-rendering same images on size change
          // eslint-disable-next-line no-param-reassign
          delete productVariation.bylImages;
        }

        Object.assign(state.details.product, productVariation);

        // eslint-disable-next-line no-underscore-dangle
        const EventBus = this._vm.$eventBus;

        EventBus.$emit('product:updated', productVariation);

        if (hasColorChanged) {
          EventBus.$emit('product:color-updated', productVariation);
          state.loading = false;
        }

        if (hasSizeChanged) {
          // eslint-disable-next-line vue/custom-event-name-casing
          EventBus.$emit('product:sizeUpdated', productVariation);
        }
      }
    },
  },
  actions: {
    load({ commit, state }, productId) {
      if (!state.urls.productShow) return;

      commit('loading');

      // URLUtils.url('Product-Show', 'pid', product.id)
      Axios.get(state.urls.productShow, {
        params: {
          format: 'json',
          pid: productId,
        },
      }).then((response) => {
        commit('update', productDetails(response.data));
        commit('loading', false);
      });
    },
  },
};
